export default __webpack_public_path__ + "static/media/blue.ae6704e8.svg";